<template>
  <form id="frmLogin" onSubmit="return false;" class="form">
    <input type="hidden" id="app_key" name="app_key" value="{{eid}}" ref="app_key" v-model.trim="app_key">              
    <div class="form-group">
      <div class="input-wrapper">
        <label for="upwd">Current Password</label>
        <input type="password" id="upwd" name="upwd" ref="upwd" class="input" placeholder="Current password" v-model.trim="upwd" autocomplete="off" maxlength="20"/>
      </div>
    </div> 
    <div class="form-group">
      <div class="input-wrapper">
        <label for="upwd1">New Password</label>
        <input type="password" id="upwd1" name="upwd1" ref="upwd1" class="input" placeholder="8 to 20 characters." v-model.trim="upwd1" autocomplete="off" maxlength="20"/>
      </div>
    </div>              
      <div class="form-group">
        <div class="input-wrapper">
          <label for="upwd2">Confirm New Password</label>
          <input type="password"  id="upwd2" name="upwd2" ref="upwd2" class="input" placeholder="8 to 20 characters." v-model.trim="upwd2" autocomplete="off" maxlength="20"/>
        </div>
      </div>  
      <button type="button" name="login" id="login" class="btn-reset" @click="lfnLogin">Save</button>
  </form>     
</template>
<script>
String.prototype.trim = function() { return this.replace(/^\s+|\s+$/g,""); }
import $ from 'jquery';
import { lfnSetpassword } from '@/Service/Login/pwdchanger';
export default{
   name: "pwdchanger",
   data() {
      return {
        upwd: "",        
        upwd1: "",
        upwd2: "",
        now_year: '',        
        eid : "",
        ret : "",
        app_key: ""
    };
  },
  mounted() {
    this.onSetInitValues();
  },
  methods: {
      onSetInitValues(){
        let params = (new URL(window.location)).searchParams;
        this.now_year = new Date().getFullYear();
        this.eid = params.get('eid') || "";
        this.app_key = this.eid;
        this.ret= window.location.origin; 
      },
      lfnLogin(){
            let _app_key = $("#app_key").val();
            let _upwd = $("#upwd").val();            
            let _upwd1 = $("#upwd1").val();
            let _upwd2 = $("#upwd2").val();
            if (_app_key == "") { alert("Please return to the login page and try again."); return; }
            if (_upwd.trim() == "") { this.$refs.upwd.focus(); return; }            
            if (_upwd1.trim() == "") { this.$refs.upwd1.focus(); return; }
            if (_upwd2.trim() == "") { this.$refs.upwd2.focus(); return; }
            if (_upwd1.trim().length < 8) { 
                alert("Please set the password to at least 8 characters."); 
                return; 
            }
            if (_upwd.trim() == _upwd1.trim()) { 
                alert("The current password cannot be the same as the new password."); 
                return; 
            }
            if (_upwd1.trim() != _upwd2.trim()) { 
                alert("Please confirm the new password."); 
                return; 
            }

            let num = _upwd1.search(/[0-9]/g);
            let eng = _upwd1.search(/[a-z]/ig);
            let spe = _upwd1.search(/[`~!@@#$%^&*|₩₩₩'₩";:₩/?]/gi);

            if (_upwd1.search(/\s/) != -1) {
                alert("Please enter the password without spaces.");
                return;
            }
            else if (num < 0 || eng < 0 || spe < 0) {
                alert("Please include a combination of letters, numbers, and special characters.");
                return;
            }



            lfnSetpassword(this.eid, _upwd, _upwd1, this.ret);
      }
  }
};
</script>
